import gql from 'graphql-tag';

import client from '../graphqlAPI';

const POST_ADD_EVENT_MUTATION = gql`
  mutation Post(
    $artistSets: [String]
    $beginDateTime: String
    $description: ObjectLocalizationInput
    $endDateTime: String
    $eventsArray: [String]
    $eventName: String
    $eventReadableName: ObjectLocalizationInput
    $eventSlugName: String!
    $image: ObjectLocalizationInput
    $postSlugNames: [String]
    $showDate: Boolean!
    $showDateTime: Boolean!
    $showTicket: Boolean!
    $showVenue: Boolean!
    $tickets: [String]
    $totalCapacity: Int
    $salePostSlugName: String
    $venues: [String]
    $genres: [String]
    $timezone: String
    $mentors: [String]
  ) {
    postAddEvent(
      artistSets: $artistSets
      beginDateTime: $beginDateTime
      description: $description
      endDateTime: $endDateTime
      eventsArray: $eventsArray
      eventName: $eventName
      eventReadableName: $eventReadableName
      eventSlugName: $eventSlugName
      image: $image
      postSlugNames: $postSlugNames
      tickets: $tickets
      totalCapacity: $totalCapacity
      salePostSlugName: $salePostSlugName
      showDate: $showDate
      showDateTime: $showDateTime
      showTicket: $showTicket
      showVenue: $showVenue
      venues: $venues
      genres: $genres
      timezone: $timezone
      mentors: $mentors
    ) {
      isAuth
      isAdded
      eventSlugName
    }
  }
`;

const postAddEvent = async ({
  artistSets, beginDateTime, description, endDateTime, eventsArray, eventName, eventReadableName, eventSlugName, image,
  postSlugNames, tickets, totalCapacity, venues, showDate, showDateTime, showTicket, showVenue, genres, timezone, mentors, salePostSlugName,
}) => {
  try {
    const result = await client
      .mutate({
        mutation: POST_ADD_EVENT_MUTATION,
        variables: {
          artistSets,
          beginDateTime,
          description,
          endDateTime,
          eventsArray,
          eventName,
          eventReadableName,
          eventSlugName,
          image,
          postSlugNames,
          tickets,
          totalCapacity,
          salePostSlugName,
          venues,
          showDate,
          showDateTime,
          showTicket,
          showVenue,
          genres,
          timezone,
          mentors,
        },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { postAddEvent: postAddEventValidationData },
    } = result;

    if (postAddEventValidationData) {
      return postAddEventValidationData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postAddEventValidationData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postAddEvent Error: ${error}`);
    return null;
  }
};

export default postAddEvent;
